import { Notification } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import { rateMapper } from "apps/oneOnboarding/pricing/constants";
import { First3BookingController } from "apps/oneOnboarding/pricing/discounts/First3BookingController";
import { MonthlyPromotionController } from "apps/oneOnboarding/pricing/discounts/MonthlyPromotionController";
import { WeeklyPromotionController } from "apps/oneOnboarding/pricing/discounts/WeeklyPromotionController";
import { PromotionFooter } from "apps/oneOnboarding/pricing/promotion/PromotionFooter";
import { useStaticDataAtomValue } from "apps/oneOnboarding/staticDataAtom";
import { Fragment } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import type { BulkPropertyFormData } from "../BulkPropertyFormData";

export const BatchDiscountController = () => {
    const { control, setValue } = useFormContext<BulkPropertyFormData>();
    const {
        cmsData: {
            pricing: { first3BookingsNotice },
        },
    } = useStaticDataAtomValue();
    const propertyDataList =
        (useWatch<BulkPropertyFormData>({
            control,
            name: "propertyDataList",
        }) as BulkPropertyFormData["propertyDataList"]) ?? [];
    const isAllPropertiesManual =
        propertyDataList.length > 0 && propertyDataList.every((property) => property.rate === rateMapper.Manual);

    const handleSetFirst3BookingDiscount = (value: boolean) => {
        propertyDataList.forEach((_, index) => {
            if (index === 0) return;
            setValue(`propertyDataList.${index}.first3BookingDiscount`, value);
        });
    };

    const handleSetWeeklyDiscount = (value: number | null | "") => {
        propertyDataList.forEach((_, index) => {
            if (index === 0) return;
            setValue(`propertyDataList.${index}.weeklyDiscount`, value as number | null);
        });
    };

    const handleSetMonthlyDiscount = (value: number | null | "") => {
        propertyDataList.forEach((_, index) => {
            if (index === 0) return;
            setValue(`propertyDataList.${index}.monthlyDiscount`, value as number | null);
        });
    };

    return (
        <VStack gap="16">
            <Notification
                intent="notice"
                asset={{
                    id: "fill.symbol.lightbulb",
                }}
                title={first3BookingsNotice}
            />
            <First3BookingController fieldPrefix="propertyDataList.0" onSetValue={handleSetFirst3BookingDiscount} />
            {isAllPropertiesManual && (
                <Fragment>
                    <WeeklyPromotionController fieldPrefix="propertyDataList.0" onSetValue={handleSetWeeklyDiscount} />
                    <MonthlyPromotionController
                        fieldPrefix="propertyDataList.0"
                        onSetValue={handleSetMonthlyDiscount}
                    />
                </Fragment>
            )}
            <PromotionFooter />
        </VStack>
    );
};
